import {
  TagPreference,
  FoodProfileDisclosure,
  ControlTagSwitch,
} from '@hungryroot/page-food-profile';
import { type PaginatedCustomerTagListList } from '@hungryroot/rest';
import { useTagGroup } from '@hungryroot/rest-hooks';
import { tagGroups, useCustomerTagGroup } from '@hungryroot/tags';
import { Heading, Paragraph, DinnerCategory } from '@hungryroot/ui-kit';
import styles from './DinnerSection.module.css';

interface DinnerSectionProps {
  customerId: number;
}

function getSubtitle(
  tagMap: { [key: number]: string },
  customerTags: PaginatedCustomerTagListList
) {
  const tagNames = customerTags.results
    .filter((tag) => tag.preference === TagPreference.Selected)
    .map((tag) => {
      return tagMap[tag.tag];
    });

  return tagNames?.join(', ');
}

export function DinnerSection(props: DinnerSectionProps) {
  const { customerId } = props;

  const { data: tagGroupData } = useTagGroup(tagGroups.DinnerDishTypes);
  const tagMap = tagGroupData?.tags.reduce(
    (acc, tag) => {
      acc[tag.id] = tag.name;
      return acc;
    },
    {} as Record<number, string>
  );

  const { data: customerTagGroupData } = useCustomerTagGroup(
    tagGroups.DinnerDishTypes
  );
  const subtitle =
    tagMap !== undefined && customerTagGroupData !== undefined
      ? getSubtitle(tagMap, customerTagGroupData)
      : undefined;

  return (
    <section className={styles.container}>
      <FoodProfileDisclosure
        title="Dinner Preferences"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<DinnerCategory />}
        deepLink="dinner-preferences"
      >
        <Heading variant="H5">Do you like these kinds of dinner meals?</Heading>
        <Paragraph className={styles.text}>
          We’ll use your preferences to suggest meals that suit your tastes.
        </Paragraph>
        <ControlTagSwitch
          customerId={customerId}
          colCount={2}
          tagGroupId={tagGroups.DinnerDishTypes}
        />
      </FoodProfileDisclosure>
    </section>
  );
}
